module.exports = __webpack_public_path__ + "img/work-flow.01578630.svg";